import _ from 'underscore';

export default class UserOverview {
  constructor($scope, UserService) {
    $scope.user_id = window.user_id;
    $scope.selected_tab = 0;
    $scope.set_selected_tab = this.set_selected_tab.bind(this);

    this.UserService = UserService;
    this.$scope = $scope;
    this.load_data();
  }

  set_selected_tab(index) {
    this.$scope.selected_tab = index;
  }

  load_data() {
    this.$scope.user = {};
    this.$scope.notes = [];
    this.$scope.notes_count = 0;
    this.$scope.loading = true;

    this.UserService.get_overview_data(this.$scope.user_id)
      .then((res) => {
        this.$scope.user = res.data.user;
        this.$scope.notes = res.data.notes;
        this.$scope.notes_count = _.reduce(res.data.notes, (memo, note) => {
          return memo + note.value;
        }, 0);
        this.$scope.loading = false;
      });
  }
}

UserOverview.$inject = ['$scope', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-overview.ctrl.js